import { useMemo } from 'react';
import { ReferralData } from 'components/LMA/types';

interface UsePaginationParams {
  data: ReferralData[];
  currentPage: number;
  pageSize: number;
}

export const usePagination = ({ data, currentPage, pageSize }: UsePaginationParams) => {
  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    return data.slice(startIndex, startIndex + pageSize);
  }, [data, currentPage, pageSize]);

  const totalPages = Math.ceil(data.length / pageSize);

  return { paginatedData, totalPages };
};
